import React from "react";
import styled from "styled-components";
import backgroundImg from "../assets/gitBgImage.png";

const StyledWrapper = styled.div`
  /* background-image: linear-gradient(
    60deg,
    rgba(84, 58, 183, 1) 0%,
    rgba(0, 172, 193, 1) 100%
  ); */
  background-image: linear-gradient(120deg, #05265c, #040d21, #431d45);

  /* background-image: url(${backgroundImg}); */
  min-height: 100dvh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0;

  /* @media (min-width: 280px) and (max-width: 768px) {
    height: auto !important;
  } */
`;
const MainWrapper = (props) => {
  return <StyledWrapper {...props} />;
};

export default MainWrapper;
